/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetDataSecondStage200ResponseData } from './GetDataSecondStage200ResponseData'
import {
  GetDataSecondStage200ResponseDataFromJSON,
  GetDataSecondStage200ResponseDataFromJSONTyped,
  GetDataSecondStage200ResponseDataToJSON,
} from './GetDataSecondStage200ResponseData'

/**
 *
 * @export
 * @interface GetDataSecondStage200Response
 */
export interface GetDataSecondStage200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetDataSecondStage200Response
   */
  status: boolean
  /**
   *
   * @type {GetDataSecondStage200ResponseData}
   * @memberof GetDataSecondStage200Response
   */
  data: GetDataSecondStage200ResponseData
}

/**
 * Check if a given object implements the GetDataSecondStage200Response interface.
 */
export function instanceOfGetDataSecondStage200Response(
  value: object
): value is GetDataSecondStage200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetDataSecondStage200ResponseFromJSON(
  json: any
): GetDataSecondStage200Response {
  return GetDataSecondStage200ResponseFromJSONTyped(json, false)
}

export function GetDataSecondStage200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetDataSecondStage200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: GetDataSecondStage200ResponseDataFromJSON(json['data']),
  }
}

export function GetDataSecondStage200ResponseToJSON(
  value?: GetDataSecondStage200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: GetDataSecondStage200ResponseDataToJSON(value['data']),
  }
}
